import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetNewsletters = () => {
  const get = useTypedApiClient({
    path: '/le-connect/newsletters',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/le-connect/newsletters'],
    queryFn: async () => {
      const { data } = await get({})
      return data
    },
  })
}
